import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

import { BillType } from '../../bills/enums/billType'
import { PayableSubjectType } from '../types/payableSubjectType'

export const convertSubjectsIdsToReconciliationSubjects = (
  subjectsIds: string[],
  subjectType: PayableSubjectType,
): string[] => {
  const abstractType = mapSubjectTypeToAbstractType[subjectType]
  return subjectsIds.map((subjectId) => `Xf\\Model\\${abstractType}:${subjectId}`)
}

const mapSubjectTypeToAbstractType = {
  [BillType.Bill]: 'AbstractBill',
  [InvoiceType.Invoice]: 'AbstractInvoice',
  [InvoiceType.ExternalInvoice]: 'ExternalInvoice',
} as const
